export default "__VITE_ASSET__cce5a53f__"